import { useEffect } from "react";

const SITE = "Jaisphere";
const DEFAULT_OG = "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&w=1200&h=630&q=85";
const BASE = "https://jaisphere.com";

const upsertMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [key, val] = selector.match(/\[(.*?)="(.*?)"\]/).slice(1, 3);
    el.setAttribute(key, val);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * Lightweight per-route SEO updater.
 * Use as: <SEO title="..." description="..." path="/products/ai-inventory-compliance-governance" image="..." />
 */
export default function SEO({
  title,
  description,
  path = "/",
  image = DEFAULT_OG,
  type = "website",
}) {
  useEffect(() => {
    const isHome = path === "/" || !title;
    const fullTitle = isHome
      ? `${SITE} — Govern AI. Master Compliance.`
      : `${title} — ${SITE}`;
    const url = `${BASE}${path}`;

    document.title = fullTitle;

    if (description) {
      upsertMeta('meta[name="description"]', "content", description);
      upsertMeta('meta[property="og:description"]', "content", description);
      upsertMeta('meta[name="twitter:description"]', "content", description);
    }
    upsertMeta('meta[property="og:title"]', "content", fullTitle);
    upsertMeta('meta[name="twitter:title"]', "content", fullTitle);
    upsertMeta('meta[property="og:url"]', "content", url);
    upsertMeta('meta[property="og:type"]', "content", type);
    upsertMeta('meta[property="og:image"]', "content", image);
    upsertMeta('meta[name="twitter:image"]', "content", image);
    upsertLink("canonical", url);
  }, [title, description, path, image, type]);

  return null;
}

